module.exports = __webpack_public_path__ + "static/media/fz_verifydialogrobot_en_US.ea9671d5.png";